import { CUSTOMER_JOURNEY_CATEGORIES } from './../const';

function action(token, lang, context, successCallback, errorCallback) {
  return { type: CUSTOMER_JOURNEY_CATEGORIES, token, lang, context, successCallback, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyCategories.js